import axios from "axios";
import React, { useState } from "react";
import "./JoinPage.css";

import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function JoinPage() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("UK");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [agree, setAgree] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [capVal, setCapVal] = useState(null);
  const [marketing, setMarketing] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const passwordMatch = password && confirm && password === confirm;

  const submit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setValidated(true);

    const form = e.currentTarget;
    if (!form.checkValidity() || !passwordMatch) {
      setIsLoading(false);
      return;
    }

    try {
      const createPendingAppUser = {
        firstName,
        lastName,
        email,
        password,
        country,
        SubscribedToNewsLetter: marketing,
      };

      const pendingAccResponse = await axios.post(
        `${ApiConnectionString}/api/PendingAppUser`,
        createPendingAppUser,
      );

      if (pendingAccResponse.status === 200) {
        setComplete(true);
        setCapVal(null);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  if (complete) {
    return (
      <div className="jp">
        <section className="jp-section" id="join">
          <div className="jp-wrap">
            <div className="jp-form-card">
              <div className="jp-form-title">Account created</div>
              <div className="jp-form-sub">
                Welcome{firstName ? `, ${firstName} ${lastName}` : ""}! Your
                account has been created. Please verify your email address
                before logging in. Check your inbox and junk folder.
              </div>

              <Link to="/" className="jp-btn jp-btn-primary jp-full my-3">
                Go to login
              </Link>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="jp">
      <section className="jp-section" id="join">
        <div className="jp-wrap">
          <div className="jp-form-card">
            <div className="jp-form-title">Create your account</div>
            <div className="jp-form-sub">
              Set up your login now. You can complete your profile later.
            </div>

            <form
              className={`jp-form ${validated ? "was-validated" : ""}`}
              onSubmit={submit}
              noValidate
            >
              <div className="jp-row">
                <div className="jp-field">
                  <label className="jp-label">First name</label>
                  <input
                    className="jp-input"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                  />
                  <div className="invalid-feedback">Enter your first name</div>
                </div>

                <div className="jp-field">
                  <label className="jp-label">Last name</label>
                  <input
                    className="jp-input"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                  />
                  <div className="invalid-feedback">Enter your last name</div>
                </div>
              </div>

              <div className="jp-field">
                <label className="jp-label">Email</label>
                <input
                  type="email"
                  className="jp-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <div className="invalid-feedback">Enter a valid email</div>
              </div>

              <div className="jp-field">
                <label className="jp-label">Country</label>
                <select
                  className="jp-input"
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  required
                >
                  <option value="UK">United Kingdom</option>
                  <option value="US">United States</option>
                  <option value="CA">Canada</option>
                  <option value="AU">Australia</option>
                </select>
                <div className="invalid-feedback">Select a country</div>
              </div>

              <div className="jp-field jp-password">
                <label className="jp-label">Password</label>
                <div className="jp-password-wrap">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="jp-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={6}
                  />
                  <button
                    type="button"
                    className="jp-show-btn"
                    onClick={() => setShowPassword((x) => !x)}
                  >
                    {showPassword ? "Hide" : "Show"}
                  </button>
                </div>
                <div className="invalid-feedback">Enter a password</div>
              </div>

              <div className="jp-field jp-password">
                <label className="jp-label">Confirm password</label>
                <div className="jp-password-wrap">
                  <input
                    type={showConfirm ? "text" : "password"}
                    className={`jp-input ${
                      confirm ? (passwordMatch ? "is-valid" : "is-invalid") : ""
                    }`}
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="jp-show-btn"
                    onClick={() => setShowConfirm((x) => !x)}
                  >
                    {showConfirm ? "Hide" : "Show"}
                  </button>
                </div>
                <div className="invalid-feedback">Passwords must match</div>
              </div>
              <label className="jp-check">
                <input
                  type="checkbox"
                  className="jp-checkbox"
                  checked={marketing}
                  onChange={(e) => setMarketing(e.target.checked)}
                />
                <span className="jp-check-text">
                  I agree to receive marketing and newsletter emails.
                </span>
              </label>

              <label className="jp-check">
                <input
                  type="checkbox"
                  className="jp-checkbox"
                  checked={agree}
                  onChange={(e) => setAgree(e.target.checked)}
                  required
                />
                <span className="jp-check-text">I agree to the terms</span>
              </label>

              <div className="jp-links">
                <Link to="/privacy">Privacy Policy</Link> |{" "}
                <Link to="/agreement">User Agreement</Link>
              </div>

              <div className="jp-captcha">
                <ReCAPTCHA
                  sitekey="6LeXa0QqAAAAAOMfVHItB7SWzaKJZCQg0XeM6_d2"
                  onChange={(val) => setCapVal(val)}
                />
              </div>

              {!capVal ? (
                <button
                  type="submit"
                  disabled
                  className="jp-btn jp-btn-primary jp-full"
                >
                  Create account
                </button>
              ) : (
                <button
                  type="submit"
                  className="jp-btn jp-btn-primary jp-full"
                  disabled={isLoading}
                >
                  {isLoading ? "Creating..." : "Create account"}
                </button>
              )}

              <div className="jp-login">
                <span className="jp-muted">Already have an account</span>{" "}
                <Link to="/login">Login</Link>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
